import {CartProvider} from '@shopify/hydrogen';
import type {CountryCode} from '@shopify/hydrogen/storefront-api-types';
import {ReactElement, ReactNode} from 'react';

import {DrawerContextProvider} from '~/components/';

interface Props {
  countryCode: CountryCode;
  children?: ReactNode;
}

export function CartProviderWrapper({
  countryCode,
  children,
}: Props): ReactElement {
  return (
    <DrawerContextProvider>
      <CartProvider
        countryCode={countryCode}
        onLineAddComplete={() => {
          // TODO: find way to use useDrawerContext hook to open cart after adding product to cart
        }}
      >
        {children}
      </CartProvider>
    </DrawerContextProvider>
  );
}
